import { UnsupportedBehavior, useIdleCallback } from "@shopify/react-idle";
import { useCallback, useState } from "react";
export const useIdleState = () => {
  const [isIdle, setIsIdle] = useState(false);
  const onIdleCallback = useCallback(() => {
    setIsIdle(true);
  }, []);
  useIdleCallback(onIdleCallback, {
    unsupportedBehavior: UnsupportedBehavior.Immediate
  });
  return isIdle;
};